import { FC, ChangeEvent } from 'react'
import styles from 'styles/components/label.module.scss'
import InputText from 'components/Form/InputText'
import InputLabel from 'components/Label/InputLabel'

type Props = {
  required: boolean
  labelName: string
  description: string
  line: number
  type: string
  size: string
  margin?: string
  value: string
  placeholder: string
  rightAligned?: boolean
  errorText?: string | null
  labelSize?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onInput?: () => void
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void
  readOnly?: boolean
}

const InputTextWithLabel: FC<Props> = (props) => {
  const {
    required,
    labelName,
    description,
    line,
    type,
    size,
    margin,
    value,
    placeholder,
    rightAligned,
    errorText,
    labelSize,
    onChange,
    onInput,
    onBlur,
    readOnly,
  } = props

  const labelFormContainerStyle = (() => {
    switch (margin) {
      case 'default':
        return styles.labelFormContainer
      case 'narrow':
        return styles.labelFormContainerSub
      case 'min':
        return styles.labelFormContainerMin
      default:
        return styles.labelFormContainer
    }
  })()

  const className = `${labelFormContainerStyle}`

  return (
    <div className={className}>
      <InputLabel
        required={required}
        name={labelName}
        description={description}
        line={line}
        size={labelSize}
      />
      <div>
        <InputText
          required={required}
          type={type}
          size={size}
          value={value}
          placeholder={placeholder}
          rightAligned={rightAligned ? rightAligned : false}
          errorText={errorText}
          onChange={(e) => (onChange ? onChange(e) : null)}
          onInput={onInput}
          onBlur={onBlur}
          readOnly={readOnly}
        />
      </div>
    </div>
  )
}

export default InputTextWithLabel
